import React from 'react';
import { Platform, Pressable, ScrollView, StyleSheet, View } from 'react-native';
import Text from '@/components/Typography/Text';
import { useTheme } from '@/context/ThemeContext';

// In normal layout, outside the clipped input bubble: native hit testing cannot
// reach an absolutely positioned popup extending beyond its parent's bounds.
export default function GoalCommandSuggestions({ prompt, onSelect, onDismiss }) {
  const { colors } = useTheme();
  if (!prompt) return null;
  return (
    <View testID="goal-command-popup" style={[styles.container, {
      backgroundColor: colors.solid_color_primary,
      borderColor: colors.border_color_secondary,
    }]}>
      <ScrollView keyboardShouldPersistTaps="always" scrollEnabled={false}>
        <View style={styles.row}>
          <Pressable
            accessibilityRole="button"
            accessibilityLabel="Set a long-running goal"
            onPress={onSelect}
            {...(Platform.OS === 'web' ? { onMouseDown: event => event.preventDefault() } : {})}
            style={({ pressed }) => [styles.command, pressed && { backgroundColor: colors.solid_color_secondary }]}
          >
            <Text size="s" weight="medium" color="primary">
              /goal · Set a long-running goal
            </Text>
            <Text size="xs" color="secondary">
              Set an objective for Work to keep pursuing.
            </Text>
          </Pressable>
          <Pressable
            accessibilityRole="button"
            accessibilityLabel="Dismiss goal suggestion"
            onPress={onDismiss}
            style={styles.dismiss}
          >
            <Text size="n" color="secondary">×</Text>
          </Pressable>
        </View>
      </ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  container: { marginHorizontal: 8, marginBottom: 6, borderRadius: 12, borderWidth: 1, overflow: 'hidden', flexShrink: 0 },
  row: { flexDirection: 'row', alignItems: 'stretch' },
  command: { flex: 1, paddingHorizontal: 12, paddingVertical: 12, gap: 4 },
  dismiss: { width: 44, minHeight: 44, alignItems: 'center', justifyContent: 'center' },
});
